/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useCallback, useEffect, useRef, useState,
} from 'react';
import SearchIcon from '@mui/icons-material/Search';
import SaveIcon from '@mui/icons-material/Save';
import { Grid, Toolbar as MuiToolbar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PrintIcon from '@mui/icons-material/Print';

import { Controls } from '../../components/controls/Controls';
import { loadViaje, saveViaje, newViaje } from '../../redux/ducks/viajes';
import { setIndex } from '../../redux/ducks/sideMenuIndex';
import { setSnackbar } from '../../redux/ducks/snackbar';
import { setButton } from '../../redux/ducks/updateButton';
import { setButtonCasetas } from '../../redux/ducks/casetasButton';
import ConfirmDialog from '../../components/ConfirmDialog';
import http, { BASE_URL } from '../../http-common';

export default function Toolbar({
    isDirty, setIsDirty, values, errors, handleInputChange, validate, setValues,
}) {
    const dispatch = useDispatch();
    const [confirmDialog, setConfirmDialog] = useState({
        title: 'title',
        subtitle: 'subtitle',
        isOpen: false,
    });
    const buscaViaje = () => {
        if (isDirty) {
            setConfirmDialog({
                subtitle: '',
                title: 'Desea continuar sin guardar?',
                isOpen: true,
                onConfirm: () => {
                    setIsDirty(false);
                    dispatch(setButton(true, false));
                    dispatch(loadViaje(values.id));
                },
            });
        } else {
            setIsDirty(false);
            dispatch(loadViaje(values.id));
        }
    };

    const [disableFolio, setDisableFolio] = useState(true);
    const folioInputRef = useRef(null);

    const save = async () => {
        let password = '';
        if (validate()) {
            if (values.status === 'APROBADO') {
                password = prompt('Password', '');
            }
            dispatch(saveViaje(values, password));
            setIsDirty(false);
            dispatch(setButton(true, false));
            dispatch(setButtonCasetas(false));
            dispatch(setIndex(null, null));
        } else {
            dispatch(setSnackbar(true, 'error', 'Error al guardar, Faltan Datos'));
        }
    };

    const viajeNuevo = () => {
        dispatch(newViaje(values));
    };

    useEffect(() => {
        buscaViaje();
    }, []);

    const print = async () => {
        try {
            const response = await http.get(`/viajes/${values.id}/print`, {
                responseType: 'blob',
            });

            const file = new Blob([response.data], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            const pdfWindow = window.open();
            pdfWindow.location.href = fileURL;
        } catch (error) {
            return { error };
        }
        return '';
    };

    const aprobar = async () => {
        try {
            // eslint-disable-next-line no-alert
            const password = prompt('Password', '');
            const result = await http.put(`viajes/${values.id}/APROBADO?password=${password}`);
            if (result.status === 200) {
                if (result.data === 'ok') {
                    setValues({
                        ...values,
                        status: 'APROBADO',
                    });
                } else {
                    dispatch(setSnackbar(true, 'error', result.data));
                }
            }
        // eslint-disable-next-line no-empty
        } catch {

        }
    };
    const updateButton = useSelector((state) => state.updateButton);

    return (
        <Grid item xs={12}>
            <MuiToolbar>
                <Grid container>

                    <Grid item xs={3}>
                        <Controls.Input
                            disabled={disableFolio}
                            error={errors.id}
                            inputRef={folioInputRef}
                            label='Numero de Folio'
                            margin='dense'
                            name='id'
                            onChange={handleInputChange}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    buscaViaje();
                                    setDisableFolio(true);
                                }
                            }}
                            value={values.id === 0 ? '' : values.id}
                            width='20%'
                        />
                    </Grid>
                    <Grid item>
                        <Controls.ActionButton
                            color='primary'
                            onClick={() => {
                                viajeNuevo();
                                setDisableFolio(false);
                                setTimeout(() => folioInputRef.current?.focus(), 50);
                            }}
                        >
                            <AddCircleIcon fontSize='large' />
                        </Controls.ActionButton>
                    </Grid>
                    <Grid item>
                        <Controls.ActionButton
                            color='primary'
                            onClick={() => {
                                buscaViaje();
                                setDisableFolio(true);
                            }}
                            // eslint-disable-next-line

                        >
                            <SearchIcon fontSize='large' />
                        </Controls.ActionButton>
                    </Grid>
                    <Grid item>
                        <Controls.ActionButton
                            color={updateButton.apagado ? 'turnedOff' : 'primary'}
                            onClick={() => {
                                save();
                            }}
                            // eslint-disable-next-line
                            disabled = {updateButton.apagado}

                        >
                            <SaveIcon fontSize='large' />
                        </Controls.ActionButton>
                    </Grid>
                    <Grid item>
                        <Controls.ActionButton
                            color='primary'
                            onClick={() => {
                                print();
                            }}
                        >
                            <PrintIcon fontSize='large' />
                        </Controls.ActionButton>
                    </Grid>
                    <Grid item>
                        {
                            values.status !== undefined
                                ? values.status === 'APROBADO'
                                    ? (
                                        <Controls.Button
                                            disabled
                                            style={{
                                                background: '#90ee90',
                                            }}
                                            text='APROBADO'
                                        />
                                    )
                                    : <Controls.Button onClick={aprobar} text='Aprobar' />
                                : <></>
                        }

                    </Grid>
                </Grid>
            </MuiToolbar>
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
        </Grid>
    );
}
